class PositionService {
  getStyleFromBoundingBox(position, boundingBox, positions) {
    return {
      top: this.getTopFromPositionAndBoundingBox(position, boundingBox, positions),
      left: this.getLeftFromPositionAndBoundingBox(position, boundingBox, positions),
    };
  }

  getLeftFromPositionAndBoundingBox(position, boundingBox, positions) {
    if (!position || !boundingBox || positions.indexOf(position) === -1) {
      return 0;
    }
    const { left, width } = boundingBox;
    if (position === 'top' || position === 'bottom') {
      return left + width / 2;
    }
    if (position.startsWith('left') || position.endsWith('left')) {
      return left;
    }
    return left + width;
  }

  getTopFromPositionAndBoundingBox(position, boundingBox, positions) {
    if (!position || !boundingBox || positions.indexOf(position) === -1) {
      return 0;
    }
    const { top, height } = boundingBox;
    if (position === 'left' || position === 'right') {
      return top + height / 2;
    }
    if (position.startsWith('top') || position.endsWith('top')) {
      return top;
    }
    return top + height;
  }

  getNextPosition(currentPosition, positions) {
    const currentIndex = positions.indexOf(currentPosition);
    if (currentIndex === -1) {
      return positions[0];
    }
    const nextIndex = (currentIndex + 1) % positions.length;
    return positions[nextIndex];
  }
}

export default new PositionService();
